// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@conklin/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { orderHistorySearchFieldProductErpNumber2Styles } from "@conklin/Overrides/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber2";
import { xScreen } from "@conklin/XDL/Utilities";
import { mergeWithCss } from "@conklin/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

orderHistorySearchFieldProductErpNumber2Styles.wrapper = {
    wrapper: {
        ...mergeWithCss(myAccountFilterSectionStyles.searchFieldWrapper, {
            css: css`
                flex: 0 1 calc(100% / 3 - 12px);
                ${xScreen("lte", "md")} {
                    flex: 1;
                    min-width: calc(50% - 8px);
                    max-width: calc(50% - 8px);
                }

                ${xScreen("lte", "sm")} {
                    min-width: 100%;
                    max-width: 100%;
                }
            `,
        }),
    },
};